import React from "react";
import { Anchor, Flex } from "@govlaunch/web";
import Link from "next/link";
import ProjectPageTopIcon from "~/components/icons/ProjectPageTopIcon";
import { FormattedMessage } from "react-intl";
import useIsMobile from "~/lib/hooks/useIsMobile";
import { ChevronLeft } from "~/src/components/project/icons/ChevronLeft";

export default function ProjectHeaderNavigation() {
  const isMobile = useIsMobile();

  return (
    <Flex align="center" justify="space-between" css={{ margin: 7 }}>
      {isMobile && typeof window !== "undefined" && (
        <Flex align="center" justify="center">
          <a
            onClick={navigateBack}
            title="Go Back"
            css={{ paddingLeft: 5, paddingRight: 10, paddingTop: 3, paddingBottom: 3 }}
          >
            <ChevronLeft />
          </a>
        </Flex>
      )}
      <Flex align="center" justify="center">
        <ProjectPageTopIcon mt={-1} width={6} height={6} />

        <Link href="/projects" as="/projects" passHref={true}>
          <Anchor color="grey.600" textTransform="uppercase">
            <FormattedMessage defaultMessage="All Projects" id="FehpsD" />
          </Anchor>
        </Link>
      </Flex>
    </Flex>
  );
}

function navigateBack(event: { preventDefault: () => void }) {
  if (typeof window !== "undefined") {
    window.history.go(-1);
  }
  
  event.preventDefault();
  return false;
}
